/**
 * Plateforme multi événement e.labriquerie.net, (c) Mikaël FOURNY.
 * src/i18n/fr.controleEssai.ts
 *
 * Messages du MODE ESSAI de l'écran de contrôle (/controle) : avant le jour
 * J, l'équipe scanne un vrai badge ou un badge de test et voit le verdict
 * qu'aurait donné le contrôle réel, sans rien enregistrer. 2026-10-07,
 * demande de Mika. Fusionné dans fr.ts. Aucun nom d'événement ici : la date
 * d'ouverture vient de la configuration.
 *
 * Mikael - chef de projet - 2026-10-07
 */
export const messagesControleEssaiFr: Record<string, string> = {
  // ── Bandeau, toujours visible en mode essai ─────────────────────────────
  'controleEssai.bandeau': 'Mode essai : rien n’est enregistré. Le contrôle réel s’ouvre le {quand}.',
  'controleEssai.quand': '{jour} à {heure} h',
  'controleEssai.quandMinutes': '{jour} à {heure} h {minutes}',
  'controleEssai.bandeauSansDate': 'Mode essai : rien n’est enregistré. Le contrôle réel s’ouvre le jour de l’événement.',
  'controleEssai.bandeauApres': 'Mode essai : rien n’est enregistré. Le contrôle réel est terminé.',
  'controleEssai.consigne': 'Scannez un vrai badge ou un badge de test pour voir ce que dira le contrôle.',
  // ── Verdict d'essai ─────────────────────────────────────────────────────
  'controleEssai.titre': 'Verdict d’essai',
  'controleEssai.pastille': 'Essai',
  'controleEssai.rienEnregistre': 'Essai : rien n’a été enregistré.',
  'controleEssai.admis': 'Serait admis',
  'controleEssai.alerte': 'Serait admis avec alerte',
  'controleEssai.refuse': 'Serait refusé',
  'controleEssai.badgeTest': 'Badge de test : le jour de l’événement, il sera refusé. Seuls les vrais badges comptent.',
  'controleEssai.profil': 'Profil : {profil}',
  'controleEssai.profil.autre': 'autre profil',
  'controleEssai.profil.organisation': 'Équipe d’organisation',
  'controleEssai.mineur': 'Personne mineure',
  'controleEssai.casier': 'Un numéro de casier serait attribué (aucun n’est réservé pendant l’essai).',
  'controleEssai.cadeauLectureSeule': 'Essai : le lot n’est pas remis.',
  // ── Erreurs ─────────────────────────────────────────────────────────────
  'controleEssai.ferme': 'Le contrôle réel est ouvert : l’écran repasse en contrôle réel. Scannez à nouveau.',
  'controleEssai.horsLigne': 'Essai impossible sans réseau : rien n’a été envoyé.',
};
